import { Component, OnInit, OnDestroy, ViewChild, HostListener, NgZone,  } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { LocationStrategy, PlatformLocation, Location } from '@angular/common';
import {UserAccountService} from '../../../../core/services/user-account.service';
import {RoleService } from '../../services/role.service'
import { MatDialog } from '@angular/material/dialog';
import { AddRoleComponent } from '../../components/add-role/add-role-component';
import { take } from 'rxjs/operators';
import { AlertDialog, AlertDialogConfig } from '../../components/alert/dialog';
import { throwError } from 'rxjs';
import { Role } from '../../models/role';
@Component({
  standalone: false,
    selector: 'app-liste-roles',
    templateUrl: './liste-roles.component.html',
    styleUrls: ['./liste-roles.component.scss']
})
export class ListeRolesComponent implements OnInit, OnDestroy {
    // url: string;
    userData: any;
    displayedColumns: string[] = ['name', 'details', 'delete'];
    displayedColumnsName: string[] = ['Rôle', '',  ''];
    tableOptions: any = {
    }
    dataSource: any;
    loading : boolean = false;
    workspace_name: string | null = null;
    intervalId: any = 0;
    user_roles : string[] = []


    constructor(
      private readonly dialog_: MatDialog,
      private router: Router, location:Location,
      private breakpointObserver: BreakpointObserver,
      private userAccountService: UserAccountService,
      private rolesService: RoleService, private readonly ngZone_: NgZone) {
    }

    ngOnInit(): void {
      this.loading = true;
      this.rolesService.get()
          .subscribe(result => {
            this.dataSource = result;
            console.log(this.dataSource)
            this.loading = false;
          }
          );
    }

    longPolling(){
      this.rolesService.get()
          .subscribe(result => {
            this.dataSource = result;
            setTimeout(()=> {
              this.longPolling();
            }, 5000)
          }
          );
    }

    ngOnDestroy() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
    }

    getRowActions(){
      return [{name: 'edit', icon: 'edit', handler: this.editGroup, condition: this.isUserGrantedToEdit}]
    }

    isUserGrantedToEdit(instance: any){
      return true
    }

    editGroup(event: any, object: any){
      // this.rolesService.start(object);
    }

    renderTableActions ( data: any, type:any, row:any, meta:any ) {
      if (data.state != 'running'){
        return '<button mat-icon-button matTooltip="Basic" aria-label="Démarrer cette ressource">\
        <span class="material-symbols-outlined">play_circle</span>\
        </button>'
      }

      return ''

    }

    handleAddRoleDialog(): void {
      const dialogData = {data: {}, disableClose: true};
      const dialogDef = this.dialog_.open(AddRoleComponent, dialogData);
      dialogDef
        .afterClosed()
        .pipe(take(1))
        .subscribe(answer => {
          this.rolesService.get().subscribe(result => {
            this.dataSource =  result
          })

        });
    }

    handleEditRoleDialog(role:Role): void {
      const dialogData = {data: role, disableClose: true};
      const dialogDef = this.dialog_.open(AddRoleComponent, dialogData);
      dialogDef
        .afterClosed()
        .pipe(take(1))
        .subscribe(answer => {
          this.rolesService.get().subscribe(result => {
            this.dataSource =  result
          })

        });
    }

    handleDeleteRoleDialog(role:Role): void {

      this.rolesService.deleteResource({id: role.id, name: role.name})
      .subscribe(_ => {
        if(!_.status){
          const config = {
            title: 'Erreur',
            message: 'Une erreur est survenue lors de la suppression de cette ressource : ' + _.message,
            confirmLabel: 'OK'
          } as AlertDialogConfig;
          this.dialog_.open(AlertDialog, {data: config});
        }else{
          const config = {
            title: 'Supprimée !',
            message: _.message,
            confirmLabel: 'OK'
          } as AlertDialogConfig;
          this.dialog_.open(AlertDialog, {data: config});
          this.rolesService.get().subscribe(result => {
            this.dataSource = result;
          })
        }
      },
      error => {
        const config = {
          title: 'Erreur',
          message: 'Une erreur est survenue lors de la suppression : ' + error,
          confirmLabel: 'OK'
        } as AlertDialogConfig;
        this.dialog_.open(AlertDialog, {data: config});
        return throwError(error);
      })

    }

}
